<template>
  <div class="form-content">
    <div v-if="showQuickCreateAction" class="quick-create-btn">
      <el-popover placement="right" width="200" trigger="click">
        <el-select
          v-model="task_id"
          filterable
          clearable
          placeholder="请选择关联任务"
          @change="selectTask"
        >
          <el-option
            v-for="item in taskList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
        <el-button slot="reference" type="primary" size="mini">
          快速创建
        </el-button>
      </el-popover>
    </div>
    <el-form
      ref="companyForm"
      :inline="true"
      :model="formData"
      label-width="130px"
      class="post-form"
    >
      <el-col v-for="item in formList" :key="item.props" :span="12">
        <el-form-item
          :label="item.label"
          :prop="item.props"
          :rules="getItemRules(item)"
        >
          <template v-if="item.type === 'input'">
            <el-input
              v-model.trim="formData[item.props]"
              class="input"
              :placeholder="item.placeholder"
              clearable
            />
          </template>
          <template v-else-if="item.type === 'picker'">
            <el-select
              v-model="formData[item.props]"
              class="select"
              :placeholder="item.placeholder || '请选择'"
              :disabled="item.disabled || (item.props === 'is_sync_alipay' && !!id)"
              clearable
              filterable
            >
              <el-option
                v-for="item1 in item.selectOption"
                :key="item1.value"
                :label="item1.label"
                :value="item1.value"
              />
            </el-select>
          </template>
          <template v-else-if="item.type === 'multiplePicker'">
            <div
              :class="[
                'multiple-picker-wrap',
                {
                  'multiple-picker-wrap--with-action':
                    item.props === 'mission_ids' && showCreateTaskAction,
                },
              ]"
            >
              <el-select
                v-model="formData[item.props]"
                class="select"
                :placeholder="item.placeholder || '请选择'"
                clearable
                filterable
                multiple
                :collapse-tags="item.collapseTags || false"
                :max-collapse-tags="
                  item.maxCollapseTags != null ? item.maxCollapseTags : undefined
                "
              >
                <el-option
                  v-for="item1 in item.selectOption"
                  :key="item1.value"
                  :label="item1.label"
                  :value="item1.value"
                />
              </el-select>
              <el-button
                v-if="item.props === 'mission_ids' && showCreateTaskAction"
                class="mission-create-btn"
                type="primary"
                size="medium"
                @click="openCreateTaskDialog"
              >
                新建任务
              </el-button>
            </div>
          </template>
          <template v-else-if="item.type === 'cascader'">
            <el-cascader
              v-model="formData[item.props]"
              class="cascader"
              :placeholder="item.placeholder || '请选择'"
              clearable
              filterable
              :checkStrictly="true"
              :show-all-levels="false"
              :props="{ multiple: item.multiple }"
              :options="item.selectOption"
              :collapse-tags="item.collapseTags || false"
              :max-collapse-tags="
                item.maxCollapseTags != null ? item.maxCollapseTags : undefined
              "
            />
          </template>
          <template v-else-if="item.type === 'salary'">
            <div class="range-wrap">
              <el-col :span="10">
                <el-input
                  v-model.trim="formData.min_salary"
                  class="salary-input"
                  placeholder="最低薪资"
                />
              </el-col>
              <el-col :span="2" class="text-center">
                <span class="text-gray-500">-</span>
              </el-col>
              <el-col :span="10">
                <el-input
                  v-model.trim="formData.max_salary"
                  class="salary-input"
                  placeholder="最高薪资"
                />
              </el-col>
              <el-col :span="2">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="如若填写相同薪资，则展示固定薪资"
                  placement="right"
                >
                  <i class="el-icon-warning" />
                </el-tooltip>
              </el-col>
            </div>
          </template>
          <template v-else-if="item.type === 'age'">
            <div class="range-wrap">
              <el-col :span="10">
                <el-input
                  v-model.trim="formData.min_age"
                  class="salary-input"
                  placeholder="最小年龄"
                />
              </el-col>
              <el-col :span="2" class="text-center">
                <span class="text-gray-500">-</span>
              </el-col>
              <el-col :span="10">
                <el-input
                  v-model.trim="formData.max_age"
                  class="salary-input"
                  placeholder="最大年龄"
                />
              </el-col>
            </div>
          </template>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="岗位标签" class="full-width-item">
          <div class="section-card">
            <div class="tag-select-list">
              <el-tag
                v-for="tag in presetPostTags"
                :key="tag"
                :type="(formData.recruit_post_label || []).includes(tag) ? '' : 'info'"
                effect="plain"
                class="tag-option"
                @click="toggleLabelTag(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div class="tag-input-row">
              <el-input
                v-model.trim="customTagInput"
                class="tag-input"
                placeholder="输入自定义标签后点击右侧按钮添加"
                maxlength="20"
                clearable
                @keyup.enter.native="addCustomLabelTag"
              />
              <el-button type="primary" plain @click="addCustomLabelTag">
                添加
              </el-button>
            </div>
            <div v-if="(formData.recruit_post_label || []).length" class="selected-tag-list">
              <el-tag
                v-for="tag in formData.recruit_post_label"
                :key="tag"
                closable
                class="selected-tag"
                @close="removeLabelTag(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="工作地点" required class="full-width-item">
          <div class="section-card">
            <div
              v-for="(location, index) in formData.work_locations"
              :key="`location-${index}`"
              class="location-card"
            >
              <div class="location-grid">
                <div class="location-row">
                  <div class="location-field location-field--left">
                    <div class="location-label required">工作地点</div>
                    <el-cascader
                      v-model="location.work_city"
                      class="cascader location-control"
                      placeholder="请选择工作地点"
                      clearable
                      filterable
                      :show-all-levels="false"
                      :props="locationCascaderProps"
                      :options="cityOptions"
                    />
                  </div>
                  <div class="location-field location-field--right">
                    <div class="location-label required">详细地点</div>
                    <TencentMapPicker
                      v-model="location.address"
                      class="map-picker location-control"
                      placeholder="请点击地图选点"
                      :region-name="getWorkCityRegionName(location.work_city)"
                      :region-codes="getWorkCityRegionCodes(location.work_city)"
                      @confirmMap="handleLocationMapConfirm(index, $event)"
                    />
                  </div>
                </div>
                <div class="location-row">
                  <div class="location-field location-field--left">
                    <div class="location-label">联系人姓名</div>
                    <el-input
                      v-model.trim="location.contacts"
                      class="input location-control"
                      placeholder="请输入联系人姓名"
                      clearable
                    />
                  </div>
                  <div class="location-field location-field--right">
                    <div class="location-label">联系人电话</div>
                    <el-input
                      v-model.trim="location.contact_number"
                      class="input location-control"
                      placeholder="请输入联系人电话"
                      clearable
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="formData.work_locations.length > 1"
                class="location-action"
              >
                <el-button
                  class="location-delete-btn"
                  type="danger"
                  icon="el-icon-close"
                  circle
                  size="mini"
                  @click="removeWorkLocation(index)"
                />
              </div>
            </div>
            <div v-if="canAddWorkLocation" class="location-add-wrap">
              <el-button type="text" @click="addWorkLocation">
                +添加更多工作地点
              </el-button>
            </div>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="岗位有效期" required class="full-width-item">
          <div class="section-card validity-wrap">
            <div class="validity-item">
              <span class="validity-label required">开始时间</span>
              <el-date-picker
                v-model="formData.task_start_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="年/月/日"
                class="validity-control"
              />
            </div>
            <div class="validity-item">
              <span class="validity-label required">结束时间</span>
              <el-date-picker
                v-model="formData.task_end_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="年/月/日"
                class="validity-control"
              />
            </div>
            <div class="validity-item validity-item--switch">
              <span class="validity-label">岗位开关</span>
              <el-switch
                v-model="formData.status"
                :active-value="1"
                :inactive-value="0"
              />
            </div>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="工作日期" required class="full-width-item">
          <div class="section-card">
            <div class="option-group">
              <el-radio-group v-model="formData.work_date_status">
                <el-radio
                  v-for="item in workDateOptions"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </div>
            <div v-if="formData.work_date_status === '4'" class="weekday-group">
              <el-checkbox-group size="small" v-model="formData.work_date_list">
                <el-checkbox
                  v-for="item in weekOptions"
                  :key="item.value"
                  :label="item.value"
                  border
                  class="weekday-item"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="工作时间" required class="full-width-item">
          <div class="section-card">
            <div class="option-group">
              <el-radio-group v-model="formData.work_time_status">
                <el-radio label="0">不限</el-radio>
                <el-radio label="1">自定义</el-radio>
              </el-radio-group>
            </div>
            <el-input
              v-if="formData.work_time_status === '1'"
              v-model.trim="formData.work_time_customize"
              class="work-time-input"
              placeholder="请输入工作时间，如：9:00-18:00、19:00-24:00"
              clearable
            />
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="职位介绍" class="full-width-item">
          <div class="section-card">
            <el-input
              v-model="formData.job_remark"
              type="textarea"
              rows="5"
              placeholder="请输入职位介绍"
              maxlength="200"
              show-word-limit
            />
          </div>
        </el-form-item>
      </el-col>
    </el-form>
    <div class="btn">
      <el-button
        size="medium"
        type="primary"
        :disabled="loadingStaus"
        @click="saveConfirm"
      >
        {{ submitButtonText }}
      </el-button>
    </div>
    <el-dialog
      v-if="showCreateTaskAction"
      title="新建任务"
      :visible.sync="createTaskDialogVisible"
      width="70%"
      append-to-body
      destroy-on-close
    >
      <CreateTaskContent
        ref="createTaskContent"
        silent-qr-dialog
        :show-create-recruit-action="false"
        @confirm="handleTaskCreated"
      />
    </el-dialog>
  </div>
</template>

<script>
import json from "../../../../public/citys.json";
import { gettreeList, tog_SALARY_TYPE_LIST, SALARY_TYPE_VALUE_MAP } from "@/utils/utils";
import TencentMapPicker from "@/components/TencentMapPicker.vue";
import CreateTaskContent from "@/pages/privateTask/components/CreateTaskContent.vue";

const PRESET_POST_TAGS = [
  "师傅带教",
  "包吃",
  "包住",
  "包吃住",
  "交通补贴",
  "全勤奖",
  "五险一金",
];

const WORK_DATE_OPTIONS = [
  { label: "不限", value: "0" },
  { label: "工作日", value: "1" },
  { label: "双休日", value: "2" },
  { label: "做一休一", value: "3" },
  { label: "自定义", value: "4" },
];

const WEEK_OPTIONS = [
  { label: "周一", value: "周一" },
  { label: "周二", value: "周二" },
  { label: "周三", value: "周三" },
  { label: "周四", value: "周四" },
  { label: "周五", value: "周五" },
  { label: "周六", value: "周六" },
  { label: "周日", value: "周日" },
];

const createDefaultWorkLocation = () => ({
  work_city: [],
  address: "",
  lat: "",
  lon: "",
  contacts: "",
  contact_number: "",
});

const getDefaultFormData = () => ({
  recruit_post: "",
  category_ids: [],
  worked_num: "",
  sign_up_num: "",
  min_age: "",
  max_age: "",
  minimum_education: "",
  salary_type: "",
  min_salary: "",
  max_salary: "",
  work_type: "",
  recruit_post_label: [],
  work_locations: [createDefaultWorkLocation()],
  task_start_time: "",
  task_end_time: "",
  status: 1,
  work_date_status: "0",
  work_date_list: [],
  work_time_status: "0",
  work_time_customize: "",
  job_remark: "",
  mission_ids: [],
  renew_type: 1,
  is_sync_alipay: 1,
});

export default {
  name: "CreateEditContent",
  components: { TencentMapPicker, CreateTaskContent },
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    showCreateTaskAction: {
      type: Boolean,
      default: true,
    },
    showQuickCreateAction: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      taskList: [],
      task_id: "",
      workDateOptions: WORK_DATE_OPTIONS,
      weekOptions: WEEK_OPTIONS,
      cityOptions: json.data,
      locationCascaderProps: {
        checkStrictly: true,
      },
      presetPostTags: PRESET_POST_TAGS,
      customTagInput: "",
      formList: [
        {
          required: true,
          label: "岗位名称",
          type: "input",
          props: "recruit_post",
          placeholder: "请输入岗位名称",
        },
        {
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "category_ids",
          multiple: true,
          collapseTags: true,
          maxCollapseTags: 2,
          selectOption: [],
          placeholder: "请选择行业类型",
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "worked_num",
          placeholder: "请输入用工人数",
        },
        {
          required: false,
          label: "初始报名量",
          type: "input",
          props: "sign_up_num",
          placeholder: "请输入初始报名量",
        },
        {
          required: true,
          label: "年龄要求",
          props: "min_age",
          type: "age",
        },
        {
          required: true,
          label: "学历要求",
          type: "picker",
          props: "minimum_education",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: "1" },
            { label: "初中", value: "2" },
            { label: "高中", value: "3" },
            { label: "大专", value: "4" },
            { label: "本科及以上", value: "5" },
          ],
          placeholder: "请选择学历要求",
        },
        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: tog_SALARY_TYPE_LIST,
          placeholder: "请选择结算方式",
        },
        {
          required: true,
          label: "薪资范围",
          type: "salary",
          props: "min_salary",
        },
        {
          required: true,
          label: "工作性质",
          type: "picker",
          props: "work_type",
          placeholder: "请选择工作性质",
          selectOption: [
            { label: "全职", value: 1 },
            { label: "兼职", value: 2 },
            { label: "实习", value: 3 },
          ],
        },
        {
          required: false,
          label: "同步到支付宝就业",
          type: "picker",
          props: "is_sync_alipay",
          placeholder: "请选择是否同步到支付宝就业",
          selectOption: [
            { label: "否", value: 0 },
            { label: "是", value: 1 },
          ],
        },
        {
          required: false,
          label: "绑定任务",
          type: "multiplePicker",
          props: "mission_ids",
          collapseTags: true,
          maxCollapseTags: 1,
          selectOption: [],
          placeholder: "请选择绑定任务",
        },
      ],
      loadingStaus: false,
      formData: getDefaultFormData(),
      optionsLoaded: false,
      createTaskDialogVisible: false,
    };
  },
  computed: {
    submitButtonText() {
      return this.id ? "保存" : "发布岗位";
    },
    canAddWorkLocation() {
      return !this.id || this.formData.work_locations.length > 1;
    },
  },
  watch: {
    id() {
      if (this.optionsLoaded) {
        this.init();
      }
    },
    "formData.min_salary"(val) {
      if (val && !this.formData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.formData.min_salary = "";
      }
    },
    "formData.max_salary"(val) {
      if (val && !this.formData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.formData.max_salary = "";
      }
    },
  },
  methods: {
    toggleLabelTag(tag) {
      const list = Array.isArray(this.formData.recruit_post_label)
        ? [...this.formData.recruit_post_label]
        : [];
      const index = list.indexOf(tag);
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(tag);
      }
      this.formData.recruit_post_label = list;
    },
    addCustomLabelTag() {
      const value = (this.customTagInput || "").trim();
      if (!value) {
        this.$message.warning("请输入自定义标签");
        return;
      }
      const list = Array.isArray(this.formData.recruit_post_label)
        ? [...this.formData.recruit_post_label]
        : [];
      if (list.includes(value)) {
        this.$message.warning("该标签已添加");
        return;
      }
      list.push(value);
      this.formData.recruit_post_label = list;
      this.customTagInput = "";
    },
    removeLabelTag(tag) {
      const list = Array.isArray(this.formData.recruit_post_label)
        ? [...this.formData.recruit_post_label]
        : [];
      this.formData.recruit_post_label = list.filter((item) => item !== tag);
    },
    getItemRules(item) {
      if (!item.required) return [];
      const pickerTypes = ["picker", "cascader", "multiplePicker"];
      return [
        {
          required: true,
          message: `${pickerTypes.includes(item.type) ? "请选择" : "请输入"}${item.label}`,
          trigger: pickerTypes.includes(item.type) ? "change" : "blur",
        },
      ];
    },
    openCreateTaskDialog() {
      this.createTaskDialogVisible = true;
    },
    async handleTaskCreated(taskId) {
      await this.getQuickMissionList();
      const missionIds = Array.isArray(this.formData.mission_ids)
        ? [...this.formData.mission_ids]
        : [];
      if (taskId && !missionIds.includes(taskId)) {
        missionIds.push(taskId);
      }
      this.formData.mission_ids = missionIds;
      this.createTaskDialogVisible = false;
      this.$message.success("任务创建成功");
    },
    addWorkLocation() {
      if (!this.canAddWorkLocation && this.id) return;
      this.formData.work_locations.push(createDefaultWorkLocation());
    },
    removeWorkLocation(index) {
      if (this.formData.work_locations.length <= 1) return;
      this.formData.work_locations.splice(index, 1);
    },
    handleLocationMapConfirm(index, payload) {
      const row = this.formData.work_locations[index];
      if (!row) return;
      row.address = payload.address;
      row.lat = payload.lat;
      row.lon = payload.lon;
    },
    getRegionLabelByCodes(tree, codes) {
      if (!tree || !codes || !codes.length) return "";
      let list = tree;
      const labels = [];
      for (let i = 0; i < codes.length; i++) {
        const node = list.find((n) => String(n.value) === String(codes[i]));
        if (!node) break;
        labels.push(node.label || "");
        list = node.children || [];
      }
      return labels.join("");
    },
    getWorkCityRegionCodes(workCity) {
      if (!Array.isArray(workCity) || workCity.length === 0) return [];
      const isCode = workCity.every(
        (v) => typeof v === "string" || typeof v === "number"
      );
      return isCode ? workCity : [];
    },
    getWorkCityRegionName(workCity) {
      if (!Array.isArray(workCity) || workCity.length === 0) return "";
      return this.getRegionLabelByCodes(json.data, workCity) || workCity[workCity.length - 1] || "";
    },
    normalizeStringArray(value, separatorRegex = /[，,、\s]+/) {
      if (Array.isArray(value)) {
        return value
          .map((item) => String(item || "").trim())
          .filter(Boolean);
      }
      if (typeof value === "string") {
        return value
          .split(separatorRegex)
          .map((item) => item.trim())
          .filter(Boolean);
      }
      return [];
    },
    normalizeLocation(row = {}) {
      const workCity = Array.isArray(row.work_city)
        ? row.work_city.filter(Boolean)
        : [row.province, row.city, row.area].filter(Boolean);
      return {
        work_city: workCity,
        address: row.address || row.detail_address || "",
        lat: row.lat || "",
        lon: row.lon || "",
        contacts: row.contacts || "",
        contact_number: row.contact_number || "",
      };
    },
    resetFormData() {
      this.task_id = "";
      this.formData = getDefaultFormData();
      this.$nextTick(() => {
        this.$refs.companyForm && this.$refs.companyForm.clearValidate();
      });
    },
    async getDailyTaskIndustryList() {
      const res = await this.$api.getDailyTaskIndustryList();
      const options = gettreeList(res, "industry_type_name", "id");
      this.formList.forEach((item) => {
        if (item.props === "category_ids") {
          item.selectOption = options;
        }
      });
    },
    selectTask(e) {
      const currentTask = this.taskList.find((item) => e == item.id);
      if (!currentTask) return;
      const currentLocation = {
        work_city: [currentTask.province, currentTask.city, currentTask.area].filter(Boolean),
        address: currentTask.address || "",
        lat: currentTask.lat || "",
        lon: currentTask.lon || "",
        contacts: currentTask.contacts || "",
        contact_number: currentTask.contact_number || "",
      };
      this.formData = {
        ...this.formData,
        renew_type: 1,
        is_sync_alipay: 1,
        recruit_post: currentTask.title || currentTask.recruit_post || "",
        minimum_education:
          currentTask.min_qualification !== undefined &&
          currentTask.min_qualification !== null
            ? String(currentTask.min_qualification)
            : "",
        min_salary: currentTask.min_salary,
        max_salary: currentTask.max_salary,
        worked_num: currentTask.person_num,
        salary_type: SALARY_TYPE_VALUE_MAP[parseInt(currentTask.salary_type, 10)],
        work_locations: [currentLocation],
      };
    },
    async getQuickMissionList() {
      const res = await this.$api.get_quick_mission_list();
      this.taskList = res || [];
      const options = this.taskList.map((t) => ({
        label: t.title || t.name || t.recruit_post || String(t.id),
        value: t.id,
      }));
      this.formList.forEach((item) => {
        if (item.props === "mission_ids") {
          item.selectOption = options;
        }
      });
    },
    validateInitialSignupCount() {
      if (
        this.formData.sign_up_num === "" ||
        this.formData.sign_up_num === null ||
        this.formData.sign_up_num === undefined
      ) {
        return true;
      }
      const count = Number(this.formData.sign_up_num);
      if (!Number.isInteger(count) || count < 0) {
        this.$message.error("初始报名量请输入大于等于 0 的整数");
        return false;
      }
      return true;
    },
    validateSalaryRange() {
      const { min_salary, max_salary, salary_type } = this.formData || {};
      if (!salary_type) {
        this.$message.error("请先选择结算方式");
        return false;
      }
      if (!max_salary) {
        this.$message.error("请输入最高薪资金额");
        return false;
      }
      if (!min_salary) {
        this.$message.error("请输入最低薪资金额");
        return false;
      }
      const minVal = Number(min_salary);
      const maxVal = Number(max_salary);
      if (Number.isNaN(minVal) || Number.isNaN(maxVal)) {
        this.$message.error("薪资范围需为数字");
        return false;
      }
      if (minVal > maxVal) {
        this.$message.error("最低薪资不能高于最高薪资");
        return false;
      }
      const salaryLimits = {
        1: { min: 100, max: 20000 },
        2: { min: 10, max: 500 },
        3: { min: 80, max: 5000 },
        4: { min: 500, max: 20000 },
        5: { min: 2000, max: 100000 },
        6: { min: 1000, max: 500000 },
      };
      const limit = salaryLimits[salary_type];
      if (limit) {
        if (minVal < limit.min) {
          this.$message.error(`最低薪资为${limit.min}元`);
          return false;
        }
        if (maxVal > limit.max) {
          this.$message.error(`超出薪资上限${limit.max}元`);
          return false;
        }
      }
      return true;
    },
    validateWorkLocations() {
      if (!Array.isArray(this.formData.work_locations) || !this.formData.work_locations.length) {
        this.$message.error("请至少填写一条工作地点");
        return false;
      }
      const phoneReg = /^1\d{10}$/;
      for (let i = 0; i < this.formData.work_locations.length; i++) {
        const row = this.formData.work_locations[i];
        if (!Array.isArray(row.work_city) || !row.work_city.length) {
          this.$message.error(`第${i + 1}条工作地点：请选择工作地点`);
          return false;
        }
        if (!row.address) {
          this.$message.error(`第${i + 1}条工作地点：请填写详细地点`);
          return false;
        }
        if (row.contact_number && !phoneReg.test(String(row.contact_number))) {
          this.$message.error(`第${i + 1}条工作地点：联系人电话格式不正确`);
          return false;
        }
      }
      return true;
    },
    validateCustomSections() {
      if (!this.validateInitialSignupCount()) {
        return false;
      }
      if (!this.validateWorkLocations()) {
        return false;
      }
      if (!this.formData.task_start_time || !this.formData.task_end_time) {
        this.$message.error("请选择岗位有效期");
        return false;
      }
      if (this.formData.task_start_time > this.formData.task_end_time) {
        this.$message.error("岗位有效期开始时间不能晚于结束时间");
        return false;
      }
      if (
        this.formData.work_date_status === "4" &&
        !this.formData.work_date_list.length
      ) {
        this.$message.error("请选择自定义工作日期");
        return false;
      }
      if (
        this.formData.work_time_status === "1" &&
        !String(this.formData.work_time_customize || "").trim()
      ) {
        this.$message.error("请输入工作时间");
        return false;
      }
      return true;
    },
    async saveConfirm() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          if (!this.validateSalaryRange()) return;
          if (!this.validateCustomSections()) return;
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    normalizeCategoryIds(categoryIds) {
      if (!Array.isArray(categoryIds)) return [];
      if (Array.isArray(categoryIds[0])) {
        return categoryIds.map((item) => item[item.length - 1]);
      }
      return [...categoryIds];
    },
    buildWorkLocationPayload() {
      return this.formData.work_locations.map((row) => {
        const workCity = Array.isArray(row.work_city) ? row.work_city : [];
        return {
          ...row,
          province: workCity[0] || "",
          city: workCity[1] || "",
          area: workCity[2] || "",
          work_city: [...workCity],
          work_city_text: this.getRegionLabelByCodes(json.data, workCity),
        };
      });
    },
    buildSubmitData() {
      const workLocations = this.buildWorkLocationPayload();
      const firstLocation = workLocations[0] || createDefaultWorkLocation();

      // 原有提交字段（保持不变）
      const base = {
        ...this.formData,
        category_ids: this.normalizeCategoryIds(this.formData.category_ids),
        work_locations: workLocations,
        work_date_list:
          this.formData.work_date_status === "4"
            ? [...this.formData.work_date_list]
            : [],
        work_time_customize:
          this.formData.work_time_status === "1"
            ? this.formData.work_time_customize
            : "",
        start_date: this.formData.task_start_time,
        end_date: this.formData.task_end_time,
        status: this.formData.status,
        province: firstLocation.province || "",
        city: firstLocation.city || "",
        area: firstLocation.area || "",
        work_city: [...(firstLocation.work_city || [])],
        address: firstLocation.address || "",
        lat: firstLocation.lat || "",
        lon: firstLocation.lon || "",
        contacts: firstLocation.contacts || "",
        contact_number: firstLocation.contact_number || "",
      };
      // 报名数量
      const signUpNum =
        this.formData.sign_up_num != null &&
        this.formData.sign_up_num !== ""
          ? String(this.formData.sign_up_num)
          : "";

      // 地址数组：省市区 + 地址 + 联系方式
      const addressArr = workLocations.map((item) => ({
        province: item.province || "",
        city: item.city || "",
        area: item.area || "",
        address: item.address || "",
        contacts: item.contacts || "",
        contact_number: item.contact_number || "",
        lon: item.lon != null ? String(item.lon) : "",
        lat: item.lat != null ? String(item.lat) : "",
      }));

      const workDateStatus =
        this.formData.work_date_status || "0"; // 工作日期类型
      const workDateCustomize =
        this.formData.work_date_status == "4"
          ? (this.formData.work_date_list || [])
              .map((v) => String(v))
              .filter(Boolean)
              .join(",")
          : ""; // 自定义工作日期

      // 工作时间类型：0不限 1自定义
      const workTimeStatus =
        this.formData.work_time_status == "1" ? "1" : "0"; // 工作时间类型：0不限 1自定义
      const workTimeCustomize =
          this.formData.work_time_status == "1" ? String(this.formData.work_time_customize || "") : ""; // 自定义工作时间

      // 标签 / 行业 / 任务 id 字符串数组（仅作为新增字段）
      const tagIdsStr = Array.isArray(this.formData.tag_ids)
        ? this.formData.tag_ids.map((v) => String(v))
        : [];
      const categoryIdsStr = this.normalizeCategoryIds(
        this.formData.category_ids
      ).map((v) => String(v));
      const missionIdsStr = Array.isArray(this.formData.mission_ids)
        ? this.formData.mission_ids.map((v) => String(v))
        : [];

      // 新岗位标签名称数组：来自表单维护的 recruit_post_label
      const labelArr = Array.isArray(this.formData.recruit_post_label)
        ? [...this.formData.recruit_post_label]
        : [];

      return {
        ...base,
        sign_up_num: signUpNum,
        label_arr: labelArr,
        address_arr: addressArr,
        task_start_time: this.formData.task_start_time || "",
        task_end_time: this.formData.task_end_time || "",
        work_date_status: workDateStatus,
        work_date_customize: workDateCustomize,
        work_time_status: workTimeStatus,
        work_time_customize: workTimeCustomize,
        tag_ids_str: tagIdsStr,
        category_ids_str: categoryIdsStr,
        mission_ids_str: missionIdsStr,
        status: this.formData.status,
      };
    },
    async formSubmit() {
      this.loadingStaus = true;
      try {
        const submitData = this.buildSubmitData();
        let res;
        if (this.id) {
          res = await this.$api.recruitTaskUpdate(this.id, submitData);
        } else {
          res = await this.$api.recruitTaskAdd(submitData);
        }
        if (res) {
          this.$notify.success(this.id ? "保存成功！" : "发布成功！");
          this.$emit("confirm", res);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingStaus = false;
      }
    },
    async init() {
      this.resetFormData();
      if (!this.id) return;
      const data = await this.$api.recruitTaskDetail({ id: this.id });
      const workLocations = Array.isArray(data.work_locations) && data.work_locations.length
        ? data.work_locations.map((item) => this.normalizeLocation(item))
        : [this.normalizeLocation(data)];
      this.formData = {
        ...getDefaultFormData(),
        ...data,
        category_ids: data.recruit_post_category_ids || data.category_ids || [],
        minimum_education:
          data.minimum_education === undefined || data.minimum_education === null
            ? ""
            : String(data.minimum_education),
        renew_type: data.renew_type || 1,
        is_sync_alipay:
          data.is_sync_alipay === undefined || data.is_sync_alipay === null
            ? 1
            : data.is_sync_alipay,
        mission_ids: Array.isArray(data.mission_ids) ? data.mission_ids : [],
        sign_up_num: data.sign_up_num || 0,
        work_locations: workLocations,
        task_start_time: data.task_start_time || "",
        task_end_time: data.task_end_time || "",
        status:data.status,
        work_date_status:data.work_date_status+'',
        work_date_list: data.work_date_customize.split(",") || [],
        work_time_status: data.work_time_status+'',
        work_time_customize: data.work_time_customize || "",
        recruit_post_label:data.recruit_post_label || [],
      };
    },
    async loadBaseData() {
      this.loadingStaus = true;
      try {
        await Promise.all([
          this.getQuickMissionList(),
          this.getDailyTaskIndustryList(),
        ]);
        this.optionsLoaded = true;
        await this.init();
      } finally {
        this.loadingStaus = false;
      }
    },
  },
  mounted() {
    this.loadBaseData();
  },
};
</script>

<style lang="scss" scoped>
.el-icon-warning {
  margin: 5px 0 0 4px;
  color: #409eff;
  font-size: 18px;
}

.text-center {
  text-align: center;
}

.form-content {
  display: flex;
  flex-flow: column nowrap;

  .post-form {
    width: 100%;
  }

  .multiple-picker-wrap {
    display: flex;
    align-items: center;
  }

  .multiple-picker-wrap--with-action {
    gap: 8px;
  }

  .select,
  .input,
  .cascader {
    width: 260px;
  }

  .map-picker {
    width: 260px;
  }

  .range-wrap {
    width: 260px;
  }

  .salary-input {
    width: 100%;
  }

  .mission-create-btn {
    flex-shrink: 0;
  }

  .full-width-item {
    width: 100%;
  }

  .section-card {
    width: 100%;
    padding: 14px 16px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;
  }

  .tag-select-list,
  .selected-tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .tag-option {
    cursor: pointer;
    user-select: none;
  }

  .tag-input-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 14px 0 10px;
  }

  .tag-input {
    width: 420px;
  }

  .selected-tag {
    margin-bottom: 2px;
  }

  .location-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;

    & + .location-card {
      margin-top: 12px;
    }
  }

  .location-action {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .location-delete-btn {
    padding: 5px;
  }

  .location-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }

  .location-row {
    display: flex;
    gap: 16px;
  }

  .location-field {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 12px;
    flex: 1;
  }

  .location-field--left {
    flex: 0 0 42%;
  }

  .location-field--right {
    flex: 1;
  }

  .location-label {
    flex-shrink: 0;
    width: 88px;
    font-weight: 600;
    color: #303133;
    white-space: nowrap;
    text-align: right;
    line-height: 32px;
  }

  .location-control {
    width: 100%;
  }

  .required::before {
    content: "*";
    margin-right: 4px;
    color: #f56c6c;
  }

  .location-add-wrap {
    margin-top: 10px;
    text-align: center;
  }

  .validity-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
  }

  .validity-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .validity-item--switch {
    margin-left: auto;
  }

  .validity-label {
    font-weight: 600;
    color: #303133;
  }

  .validity-control {
    width: 180px;
  }

  .weekday-group {
    display: flex;
    flex-wrap: wrap;
  }

  .weekday-item {
    margin-right: 8px;
    margin-bottom: 8px;
    margin-left: 0;
  }

  .work-time-input {
    width: 420px;
  }

  .btn {
    display: flex;
    justify-content: center;
  }
}

.quick-create-btn {
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
}

::v-deep .post-form .el-form-item {
  margin-bottom: 18px;
}

::v-deep .post-form .full-width-item .el-form-item__content {
  width: calc(100% - 130px);
}
</style>
